// extracted by mini-css-extract-plugin
module.exports = {"changeList":"index_changeList__1Ti_l","title":"index_title__12pPe","list":"index_list__1oced","item":"index_item__3BIx2","name":"index_name__hgvNM","active":"index_active__2pRqP"};